import { initializeApp } from "firebase/app"

const initializeFirebaseApp = () =>
  initializeApp({
    apiKey: "AIzaSyCMSehobrUnGP3lWVTuqJavQyGfHyNxEYM",
    projectId: "angus-58d11",
    messagingSenderId: "112239835514",
    appId: "1:112239835514:web:9e8f718876f65631a53ec3"
  })

export default initializeFirebaseApp
